import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createManualVerificationStages } from "../api.ts";
import { donationsVerificationKeys } from "../queries/keys.ts";
import { success } from "@";

export const useCreateManualVerificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orderId: number) => {
      const response = await createManualVerificationStages(orderId);
      return response.data;
    },
    onSuccess: async () => {
      success("تم إنشاء التوثيق اليدوي بنجاح");
      await queryClient.invalidateQueries({
        queryKey: [...donationsVerificationKeys.all],
      });
    },
    onError: async (error) => {
      console.error("useCreateManualVerificationMutation:error", error);
    },
  });
};
